export enum OrderTypeEnum {
  Market = 'Market',
  Limit = 'Limit',
  Stop = 'Stop',
  StopLimit = 'StopLimit',
  Pegged = 'Pegged',
}
